__turbopack_context__.v({
  "bgImg": "HeaderNav-module__eAaJ1W__bgImg",
  "isActive": "HeaderNav-module__eAaJ1W__isActive",
  "linkBg": "HeaderNav-module__eAaJ1W__linkBg",
  "nav": "HeaderNav-module__eAaJ1W__nav",
});
